import { useMemo, useState } from "react";
import { createMoveTool } from "../tools/moveTool";
import { createEraseTool } from "../tools/eraseTool";
import { createBrushTool } from "../tools/brushTool";
import { createDrawRectTool } from "../tools/drawRectTool";
const TOOL_BUILDERS = [
    createBrushTool,
    createDrawRectTool,
    createEraseTool,
    createMoveTool,
];
const TOOL_IDS = new Set(TOOL_BUILDERS.map(builder => builder.toolID));
export const useTools = (props) => {
    const [selectedToolID, _setSelectedToolID] = useState(TOOL_BUILDERS[0].toolID);
    const setTool = (tool) => TOOL_IDS.has(tool.id) && _setSelectedToolID(tool.id);
    const tools = useMemo(() => TOOL_BUILDERS.map(createTool => createTool(props)), [props.hexMapModelContext, props.highlightLayerContext, props.viewStateContext]);
    const selectedTool = useMemo(() => tools.find(t => t.id === selectedToolID), [selectedToolID, tools]);
    return [selectedTool, tools, setTool];
};
//# sourceMappingURL=tools.js.map